import React, { useState, createContext } from 'react';
import {IntlProvider} from 'react-intl'

import fr from '../lang/fr'
import en from '../lang/en'
import chi from '../lang/chi'
export const LangContext = createContext({});
export const LangProvider = ({ children }) => {
  const langauge = window.localStorage.getItem('lang')
  const [lang, setLang] = useState( langauge ? langauge : 'en');
  // const [showIntro, setShowIntro] = useState();

  return (
    <LangContext.Provider value={{ lang, setLang }}>
      <IntlProvider messages={lang === 'en' ? en: lang === 'fr' ?  fr: chi} locale={lang} defaultLocale={lang}>
        {children}
      </IntlProvider>
    </LangContext.Provider>
  );
};